/**
 * The part of a URL that says which page it is, for a list grouped by domain:
 * printed as bare hosts, four leaks on one site are four identical rows. The
 * query string stays — paste sites put a page's whole identity in it.
 */
export function urlPath(raw: string): string {
  try {
    const parsed = new URL(raw);
    return `${parsed.pathname}${parsed.search}`;
  } catch {
    // Not parseable is not a reason to show nothing: whatever was stored is
    // still the most informative thing available.
    return raw;
  }
}
